import { FC, Suspense } from 'react';
import { Image, MainLayout, Page, MainArea } from '@salecycle/ui-component-library';
import { AuthWrapper, FormWrapper, FormContent, Logo } from './styles';
import { LanguagePicker } from '../components/LanguagePicker/LanguagePicker';
import styled from 'styled-components';
import AppLoader from '../components/AppLoader';

const BackgroundContainer = styled.div`
  position: fixed;
  inset: 0;
  overflow: hidden;
  z-index: -1;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LanguageContainer = styled.div`
  float: right;
`;

export const AuthPage: FC = ({ children }) => {
  const LanguageSelector = () => {
    return (
      <Suspense fallback={<AppLoader />}>
        <LanguageContainer>
          <LanguagePicker />
        </LanguageContainer>
      </Suspense>
    );
  };

  return (
    <>
      <BackgroundContainer>
        <Image src="/images/sc-auth-background.svg" alt="SaleCycle Background" />
      </BackgroundContainer>
      <MainLayout>
        <MainArea>
          <Page>
            <AuthWrapper>
              <Logo>
                <Image src="/images/sc-full-logo.svg" alt="SaleCycle Logo" />
                <LanguageSelector />
              </Logo>

              <FormWrapper>
                <FormContent>{children}</FormContent>
              </FormWrapper>
            </AuthWrapper>
          </Page>
        </MainArea>
      </MainLayout>
    </>
  );
};

export default AuthPage;
